export default "__VITE_ASSET__6sUPp7Yz__"